import {combineReducers} from 'redux'
import {
  isNotSelectedMaterialReducer,
  isThereNonSavedFormReducer,
  modalReducer,
  projectEditingReducer,
  projectReducer,
  projectStatusReducer,
  statusServerResponseReducer,
  termUseReducer,
  userProfileReducer,
} from '../ModalPopup/reducer'

export const AppReducer = combineReducers({
  popup: modalReducer,
  userProfileData: userProfileReducer,
  projectData: projectReducer,
  projectEditing: projectEditingReducer,
  isThereNonSavedForm: isThereNonSavedFormReducer,
  isNotSelectedMaterial: isNotSelectedMaterialReducer,
  termUser: termUseReducer,
  projectStatus: projectStatusReducer,
  statusServerResponseReducer: statusServerResponseReducer,
})
